import React, { createContext, useContext, useState, useEffect } from 'react';
import en from './translations/en';
import sk from './translations/sk';
import cz from './translations/cz';
import pl from './translations/pl';
import hu from './translations/hu';
import de from './translations/de';
import uk from './translations/uk';

const dicts = { en, sk, cz, pl, hu, de, uk };
export const LANGS = Object.keys(dicts);
const STORAGE_KEY = 'sjy_lang';

const LanguageContext = createContext({
  lang: 'en',
  setLang: () => {},
  t: (key) => key,
  tr: en,
});

function resolve(dict, key) {
  const parts = key.split('.');
  let node = dict;
  for (let i = 0; i < parts.length; i++) {
    if (node == null) return undefined;
    node = node[parts[i]];
  }
  return node;
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return dicts[saved] ? saved : 'en';
    } catch (e) {
      return 'en';
    }
  });

  const setLang = (l) => {
    try { localStorage.setItem(STORAGE_KEY, l); } catch (e) {}
    setLangState(l);
  };

  // Keep <html lang> in sync so screen readers use the right voice (WCAG 3.1.1).
  // Internal keys mostly match ISO 639-1; Czech is 'cs' though.
  useEffect(() => {
    document.documentElement.lang = lang === 'cz' ? 'cs' : lang;
  }, [lang]);

  // t('section.key') -> translated string, falling back to English, then the key itself
  const t = (key) => {
    const val = resolve(dicts[lang], key);
    if (val !== undefined) return val;
    const enVal = resolve(en, key);
    return enVal !== undefined ? enVal : key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tr: dicts[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
